var map = {
	"./BDShop-card.png": 7403,
	"./Insomnia.png": 5280,
	"./LaGalaxy-card.png": 1498,
	"./Middleware-card.png": 5589,
	"./Natech-card.png": 7204,
	"./Salesforce-card.png": 9314,
	"./TP-card.png": 3441,
	"./defaultApp-card.png": 1429,
	"./eDental-card.png": 5472,
	"./smilers-card.png": 280,
	"./talend.png": 326,
	"./yooz-card.png": 5940
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2010;